import * as React from 'react';
import { observer } from 'mobx-react';

import DateFormatSelection from './DateFormatSelection';
import { saveDateFormatSelection } from '../orchestration/saveRegionalOption';

const styles = require('./Regional.scss');

@observer
export default class DateFormatQuickSelection extends React.Component<{}, {}> {
    render() {
        return (
            <div className={styles.quickSettingOption}>
                <DateFormatSelection
                    showExampleWithDateFormatLabel={false}
                    onSave={saveDateFormatSelection}
                    isQuick={true}
                />
            </div>
        );
    }
}
